/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import React from "react";
import { Dialog } from "@mui/material";
import Slide from "@mui/material/Slide";

const DialogTransition = React.forwardRef((props, ref) => {
  return <Slide direction="down" {...props} ref={ref} />;
});

interface Props {
  open: boolean;
  fullWidth?: boolean;
  disableEscapeKeyDown?: boolean;
  fullScreen?: boolean;
  onClose: () => void;
  onBackdropClick?: () => void;
  onEnterKey?: () => void;
  renderTitle: () => Object;
  renderContent: () => Object;
  renderActions: () => Object;
}

export function onEnterKeyHandler(event: any, confirmFunction: () => void) {
  if (event.key === "Enter" || event.keyCode === 13) {
    confirmFunction();
  }
}

const GenericDialog = React.memo((props: Props) => {
  const {
    disableEscapeKeyDown,
    fullWidth,
    fullScreen,
    open,
    onEnterKey,
    onClose,
    onBackdropClick,
  } = props;
  return (
    <Dialog
      sx={{
        "& .MuiBackdrop-root": { background: "transparent", padding: 0 },
        "& .MuiPaper-elevation": { boxShadow: "rgba(100, 100, 111, 0.2) 0px 2px 5px 0px;" },
      }}
      disableEscapeKeyDown={disableEscapeKeyDown}
      fullWidth={fullWidth}
      fullScreen={fullScreen}
      open={open}
      TransitionComponent={DialogTransition}
      keepMounted
      scroll="paper"
      onClose={onClose}
      onBackdropClick={onBackdropClick && onClose}
      // onEscapeKeyDown={onClose}
      onKeyDown={onEnterKey || ((event) => onEnterKeyHandler(event, props.onClose))}
    >
      {props.renderTitle && props.renderTitle()}
      {props.renderContent && props.renderContent()}
      {props.renderActions && props.renderActions()}
    </Dialog>
  );
});

export default GenericDialog;
